import React from "react";
import { Receipt } from "lucide-react";
import AiUsageSection from "@/components/AiUsageSection";
import ReuseRevenueSection from "@/components/ReuseRevenueSection";
import NetworkCostsSection from "@/components/billing/network/NetworkCostsSection";

export default function BillingPage() {
    return (
        <div className="px-8 py-8" data-testid="billing-page">
            <div className="flex items-start justify-between mb-8">
                <div>
                    <div className="label-xs text-[#7C3AED] flex items-center gap-2">
                        <Receipt className="w-3 h-3" /> Billing
                    </div>
                    <h1 className="font-display text-4xl tracking-tight mt-2">
                        AI Usage &amp; Cost Rollup
                    </h1>
                    <p className="text-sm text-white/50 mt-2 max-w-2xl">
                        AI costs across the Radar network, then this server's multi-tenant cost aggregation across
                        AI agents and orchestrated flows. Filter by client, site, or study; export the underlying events.
                    </p>
                </div>
            </div>

            <NetworkCostsSection />
            <AiUsageSection />
            <ReuseRevenueSection />
        </div>
    );
}
